import InfoIcon from "@material-ui/icons/Info";
import LocalParkingIcon from "@material-ui/icons/LocalParking";
import { IRoute } from "src/common/typings/routes";
import { Listing } from "./pages/Listing/index";
import { YardManagement } from "./Yard";

export const YardRoute: IRoute = {
  title: "Yard Management",
  path: "/yard",
  icon: LocalParkingIcon,
  component: YardManagement,
  guard: true,
  subRoutes: [{ icon: InfoIcon, component: Listing, path: "/listing", title: "Yard" }],
};
